import authSelector from 'modules/Auth/selectors'
import { getEligibilityCriteria } from 'modules/Events/actions'
import { getRolesListData } from 'modules/RuleEngine/action.js'
import ruleSelector from 'modules/RuleEngine/selectors'
import { getMasterSearchApi } from 'modules/Settings/actions.js'
import { getDegreeData,getNotificationCatalogues,sendNotificationBulkEmail,sendNotificationBulkEmailWhatsapp } from 'modules/Students/actions'
import instSelectorStudent from 'modules/Students/selectors'
import { connect } from 'react-redux'
import { getListOfCities, getListOfStates } from '../../../Auth/actions'
import { getJobRolePreview } from '../../../JobPreview/action'
import { getEligibilityCriteriaQualification } from '../../actions'
import Roles from '../../NewJobRole/index'
import {
  addNewCompany,
  addNewRole,
  deleteJobRole,
  getCandidateMetrics,
  getCities,
  getElasticSearchDegreeData,
  getJdDetails,
  getJobCategory,
  getListOfCompanies,
  getListOfCountries,
  getRoleDetails,
  getSpecialisationList,
  revertInEligibleStudent,
  searchCities,
  updateNewRole,
  getInEligibleCandidates
} from '../actions'
import selectors from '../selectors'

const mapStateToProps = state => ({
  countryList: selectors.getCountryList(state),
  listOfStates: authSelector.getListOfStates(state),
  listOfCities: authSelector.getListOfCities(state),
  companyList: selectors.getCompanyList(state),
  instituteCampusId: state.auth.instituteDetails.id,
  rolesList: ruleSelector.getRolesList(state),
  roleData: selectors.getRoleData(state),
  elasticSearchData: selectors.elasticSearchData(state),
  specialisationList: selectors.getSpecialisationListData(state),
  degreeList: instSelectorStudent.getStudentDegreeList(state),
  permissions: authSelector.getUserPermissions(state),
})

const mapDispatchToProps = {
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  addNewCompany,
  getListOfCompanies,
  addNewRole,
  getMasterSearchApi,
  getRolesListData,
  updateNewRole,
  getElasticSearchDegreeData,
  getSpecialisationList,
  getCandidateMetrics,
  getRoleDetails,
  getEligibilityCriteriaQualification,
  getDegreeData,
  getJobRolePreview,
  getJobCategory,
  getJdDetails,
  searchCities,
  deleteJobRole,
  getEligibilityCriteria,
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  sendNotificationBulkEmailWhatsapp,
  getCities,
  revertInEligibleStudent,
  getInEligibleCandidates
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles)
